//company
import Vue from "vue";

export function getCompanyValByKey(key) {
    let user = Vue.prototype.$store.getters['auth/user'];
    return user.company[key];
}